var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import { Button, Dialog, Text, Box, Flex, FilterChip } from 'pcln-design-system';
import { localCache } from '../localMessagsCache';
import analytics from '../analytics';
export var amenitiesMap = {
    HEALTHSVCS: 'Health Services',
    HANDFAC: 'Handicap-accessible Facilities',
    FAMFRIEND: 'Family Friendly',
    FPRKING: 'Free Parking',
    FINTRNT: 'Free Internet',
    NSMKFAC: 'Non-smoking Facilities',
    SPOOL: 'Swimming Pool',
    SUSTAIN: 'Sustainable Practices',
    KIDFRIEND: 'Kid Friendly',
    PETALLOW: 'Pets Allowed',
    RESTRNT: 'Restaurant',
    FBRKFST: 'Free Breakfast',
    FITSPA: 'Fitness and Spa',
    HOTTUB: 'Hot Tub',
    SPA: 'Spa Services',
    BUSCNTR: 'Business Center',
    SPOOLOUT: 'Outdoor Swimming Pool',
    FINTRRM: 'Free In-room Internet',
    FINTRPUB: 'Free Public Internet',
    KITCHEN: 'Kitchen Facilities',
    BCHFRNT: 'Beachfront Location',
    CASINO: 'Casino',
    FAIRSHUTTL: 'Airport Shuttle (fee)',
    AIRSHUTTL: 'Airport Shuttle',
    SPOOLIN: 'Indoor Swimming Pool',
    ADULTONLY: 'Adult Only Property',
    FINTRAVL: 'Free Internet in Common Areas',
    INCLUSIVE: 'All-Inclusive Option',
};
export var HotelFilterComponent = function (props) {
    var _a, _b;
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = React.useState({}), selectedAmenities = _d[0], setSelectedAmenities = _d[1];
    var _e = React.useState({}), prevSelectedAmenities = _e[0], setPrevSelectedAmenities = _e[1];
    var searchUrl = (props === null || props === void 0 ? void 0 : props.clientRedirectUrl) || '';
    var amenities = ((_a = props === null || props === void 0 ? void 0 : props.args) === null || _a === void 0 ? void 0 : _a.amenities) || '';
    useEffect(function () {
        var prevSelected = amenities === null || amenities === void 0 ? void 0 : amenities.split(',').reduce(function (res, key) {
            res[key] = true;
            return res;
        }, {});
        setSelectedAmenities(prevSelected);
        setPrevSelectedAmenities(prevSelected);
    }, amenities);
    var setChatMessage = props.setChatMessage, submitMessages = props.submitMessages, searchResult = props.searchResult;
    var tripFilterSummary = searchResult.tripFilterSummary;
    var hotelCount = tripFilterSummary.totalSizeFiltered;
    var onFilterClick = function () {
        analytics.log(__assign({ label: 'HotelSearchResult', message: 'ALL_HOTEL_FILTERS_LINK_CLICKED' }, props === null || props === void 0 ? void 0 : props.args));
        setIsOpen(true);
    };
    var onAllResultsLinkClick = function () {
        analytics.log(__assign({ label: 'HotelSearchResult', message: 'ALL_HOTEL_RESULTS_LINK_CLICKED', searchUrl: searchUrl }, props === null || props === void 0 ? void 0 : props.args));
        window.open(searchUrl, '_blank');
    };
    var amenityCounts = (((_b = props.searchResult) === null || _b === void 0 ? void 0 : _b.tripFilterSummary) || {}).amenityCounts;
    return (React.createElement(Flex, { alignItems: 'center', ml: 3, mt: '20px' },
        amenityCounts && (React.createElement(Button, { variation: 'subtle', onClick: onFilterClick, mr: 2, size: 'small' }, "Filter Options")),
        searchUrl && (React.createElement(Button, { variation: 'subtle', onClick: onAllResultsLinkClick, size: 'small' },
            "View ",
            hotelCount,
            " Results")),
        React.createElement(Dialog, { showCloseButton: true, scrimDismiss: false, open: isOpen, size: 'md', onOpenChange: function (isOpen) {
                if (!isOpen) {
                    setIsOpen(false);
                }
            }, borderRadius: 'xl', ariaDescription: 'Dialog to filter hotels', ariaTitle: 'Filter hotels', scrimColor: 'dark', headerContent: React.createElement(Text, null, "Available Hotel Filter Options") },
            React.createElement(Box, { p: 4 },
                amenityCounts &&
                    Object.keys(amenityCounts).map(function (key, i) {
                        var counts = amenityCounts[key];
                        var isSelected = Boolean(selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]);
                        var name = "chip-".concat(key, "-").concat(i);
                        return (React.createElement(FilterChip, { key: name, name: name, m: 1, selected: isSelected, label: "".concat((amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key, " (").concat(counts, ")"), showActionIcon: isSelected, disabled: Number(counts) === 0, onClick: function () {
                                var _a;
                                setSelectedAmenities(__assign(__assign({}, selectedAmenities), (_a = {}, _a[key] = !isSelected, _a)));
                            } }));
                    }),
                React.createElement(Box, null,
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: function (event) {
                            event.preventDefault();
                            var hasChange = amenitiesChanges(selectedAmenities, prevSelectedAmenities);
                            if (!hasChange) {
                                return;
                            }
                            var addedFilter = Object.keys(selectedAmenities).reduce(function (res, key) {
                                if ((selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]) && !(prevSelectedAmenities === null || prevSelectedAmenities === void 0 ? void 0 : prevSelectedAmenities[key])) {
                                    res += "".concat((amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key, "; ");
                                }
                                return res;
                            }, '');
                            var addedFilterOptions = addedFilter
                                ? "Refine hotel search with adding the amentities: ".concat(addedFilter, ".")
                                : '';
                            var removedFilter = Object.keys(prevSelectedAmenities).reduce(function (res, key) {
                                if (!(selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]) && (prevSelectedAmenities === null || prevSelectedAmenities === void 0 ? void 0 : prevSelectedAmenities[key])) {
                                    res += "".concat((amenitiesMap === null || amenitiesMap === void 0 ? void 0 : amenitiesMap[key]) || key, "; ");
                                }
                                return res;
                            }, '');
                            var removedFilterOptions = removedFilter
                                ? "Refine hotel search with removing the amentities: ".concat(removedFilter, ".")
                                : '';
                            var promptMessage = {
                                role: 'user',
                                content: "".concat(addedFilterOptions, "\n").concat(removedFilterOptions),
                            };
                            localCache.setLocalPrompts(promptMessage);
                            analytics.log(__assign({ label: 'HotelSearchResult', message: 'APPLY_HOTEL_FILTERS_CLICKED', addedFilterOptions: addedFilterOptions || 'none', removedFilterOptions: removedFilterOptions || 'none' }, props === null || props === void 0 ? void 0 : props.args));
                            // new message in Dialog
                            var displayMessage = __assign(__assign({}, promptMessage), { date: new Date() });
                            // display new message, in dialog
                            localCache.setLocalMessages(displayMessage);
                            var updatedChatMessages = __spreadArray([], localCache.getLocalMessages(), true);
                            setChatMessage(updatedChatMessages);
                            submitMessages(promptMessage, updatedChatMessages);
                            setIsOpen(false);
                        } }, "Apply Filters"))))));
};
function amenitiesChanges(selectedAmenities, prevSelectedAmenities) {
    return Object.keys(selectedAmenities).some(function (key) { return (selectedAmenities === null || selectedAmenities === void 0 ? void 0 : selectedAmenities[key]) !== (prevSelectedAmenities === null || prevSelectedAmenities === void 0 ? void 0 : prevSelectedAmenities[key]); });
}
//# sourceMappingURL=HotelFilterComponent.js.map